module.exports = __webpack_public_path__ + "img/quicklink-tiles-mitsu.dddda3b8.png";